import axios from "axios";
import { Marketing } from "../../Models/Marketing/MarketingModels"
import { errorService } from "../Error/ErrorService";
import { URLAPI } from "../../Setting";
import { DataMarketing } from "../../Models/Admin/AdminModels";
import { FichierService } from "../Demande/FichierService";
import dayjs from "dayjs";

export function MarketingService(){
    return{
        async getComMidisMarketingAdmin(token:string){
            let annonces:Marketing[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'marketings'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const element of data){
                    annonces.push({
                        id:element['id'],
                        '@id':element['@id'],
                        debut:element['debut'],
                        fin:element['fin'],
                        titre:element['titre'],
                        lien:element['lien'],
                        fichiers:element['fichiers'],
                        type:element['type'],
                    });
                }
            } catch (error) {
                errorService().handleError("Erreur obtention annonces", error);
                return [];
            }
            return annonces;
        },

        async getComMidisMarketingEnCours(token:string){
            let annonces:Marketing[]=[]
            try {
                const reponse = await axios.get(`${URLAPI+'marketings/encours'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const element of data){
                    annonces.push({
                        id:element['id'],
                        '@id':element['@id'],
                        debut:element['debut'],
                        fin:element['fin'],
                        titre:element['titre'],
                        lien:element['lien'],
                        fichiers:element['fichiers'],
                        type:element['type'],
                    });
                }
            } catch (error) {
                errorService().handleError("Erreur obtention annonces", error);
                return [];
            }
            return annonces;
        },

        async deleteMarketing(idMarketing:number, token:string){
            const responseMagasin = await axios.delete(
                `${URLAPI}marketing/${idMarketing}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return responseMagasin.status;
        },

        async ajoutAnnonceAdmin(data:DataMarketing, token:string){
            try {
                let status = 400

                //formattage des dates
                const dateDebutFormatte = dayjs(data.debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(data.fin).format('YYYY-MM-DD');

                const postObjectMarketing = {
                    "titre": data.titre,
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                    "lien": data.lien,
                    "fichiers": [],
                    "type":data.typeAnnonce
                }

                const responsePOSTMarketing = await axios.post(
                    `${URLAPI+'marketing'}`,
                    postObjectMarketing,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                status = responsePOSTMarketing.status

                if(status===201 && responsePOSTMarketing.data['id']){
                    if(data.fichierMarketing){
                        status = (await FichierService().postFichierMarketing(data.fichierMarketing, responsePOSTMarketing.data['id'],token)).status;
                    }
                }

                return status;


            } catch (error) {
                errorService().handleError('Erreur ajout annonce', error);
                return 400;
            }
        },

        async modificationAnnonceAdmin(data:DataMarketing, token:string){
            try {
                let status = 400
                if(data.fichiersMarketing.length>0 && data.modifFichier){
                    await FichierService().deleteFichier(data.fichiersMarketing[0].id, token);
                }

                //formattage des dates
                const dateDebutFormatte = dayjs(data.debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(data.fin).format('YYYY-MM-DD');

                const patchObjectMarketing = {
                    "titre": data.titre,
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                    "lien": data.lien,
                    "type":data.typeAnnonce
                }

                const responsePatchMarketing = await axios.patch(
                    `${URLAPI+'marketing/'+data.id}`,
                    patchObjectMarketing,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                status = responsePatchMarketing.status

                if(status===200){
                    if(data.fichierMarketing && data.modifFichier){
                        status = (await FichierService().postFichierMarketing(data.fichierMarketing, data.id,token)).status;
                    }
                }

                return status;

            } catch (error) {
                errorService().handleError('Erreur ajout annonce', error);
                return 400;
            }
        }
    }
}